const ApiService          = require('ceres/app/services/ApiService');
const AddressFieldService = require('../../../services/AddressFieldService');

import {
    isNullOrUndefined,
    isNull,
    isDefined
} from 'ceres/app/helper/utils';
import TranslationService from 'ceres/app/services/TranslationService';
import ValidationService from 'ceres/app/services/ValidationService';

Vue.component('checkout-address-select', {

    delimiters: ['${', '}'],

    props: [
        'template',
        'addressType',
        'showError'
    ],

    data() {
        return {
            editType      : '',
            addressToEdit : {
                addressSalutation: 0,
                gender    : 'male',
                countryId : this.shippingCountryId
            },
            addressOptionTypeFieldMap : {
                1  : 'vatNumber',
                4  : 'telephone',
                9  : 'birthday',
                11 : 'title'
            },
            showAddress: true,
            showAddressEditor: false,
            showAddressBook: true
        };
    },

    computed: {

        selectedAddress() {
            return this.$store.getters.getSelectedAddress(this.addressType);
        },

        addressList() {
            return this.$store.getters.getAddressList(this.addressType);
        },

        shippingCountryId() {
            return this.$store.state.localization.shippingCountryId;
        },

        isAddAddressEnabled() {

            if (this.addressType === '1') {
                return this.$store.getters.isLoggedIn || this.addressList.length < 1;
            }

            return this.$store.getters.isLoggedIn || this.addressList.length < 2;
        },

        isAddressListEmpty() {
            return !(this.addressList && this.addressList.length > 0);
        },

        ...Vuex.mapState({
            isBasketLoading: state => state.basket.isBasketLoading,
            countryList: state => state.localization.shippingCountries
        }),

        ...Vuex.mapGetters([
            'isLoggedIn'
        ])
    },

    watch: {
        selectedAddress: function () {
            if(
                this.addressType === '1' &&
                this.addressList &&
                this.addressList.length > 0 &&
                this.selectedAddress
            ) {

                this.showAddress       = true;
                this.showAddressEditor = false;
                this.showAddressBook   = true;

                this.showRemainingCollapse();

            }else if(
                this.addressType === '2' &&
                this.addressList &&
                this.addressList.length > 0 &&
                this.selectedAddress
            ) {
                this.showAddress       = true;
                this.showAddressEditor = false;
                this.showAddressBook   = true;
            }
        }
    },


    created() {

        let that = this;

        this.$options.template = this.template;
        this.addEventListener();

        if(this.isAddressListEmpty) {
            this.showAddAddress();
        }else if(
            this.addressType === '1' &&
            this.addressList &&
            this.addressList.length > 0 &&
            this.selectedAddress
        ) {
            $('document').ready(function () {
                that.showRemainingCollapse();
            });
        }

    },

    methods: {

        addEventListener() {
            ApiService.listen('AfterAccountContactLogout', () => {
                this.$store.commit('resetAddress', this.addressType);
            });
        },
        onAddressChanged(address) {
            this.$emit('address-changed', address);
        },
        toggleAddressBook() {
            this.showAddress = !this.showAddress;
        },
        toggleAddressEditor() {

            if(this.isLoggedIn) {
                //delivery same as billing and no other address in address book
                if(
                    this.addressType === '2' &&
                    this.addressList.length === 1 &&
                    this.addressList[0].id === -99
                ) {

                    this.showAddressBook   = false;
                    this.showAddressEditor = false;
                    this.showAddress       = true;

                }else{

                    this.showAddressEditor = !this.showAddressEditor;

                    if(!this.showAddressEditor) {
                        this.showAddressBook = true;
                    }
                }

            }else{
                this.showAddressEditor = !this.showAddressEditor;
                if(!this.showAddressEditor) {
                    this.showAddress = true;
                }
            }

        },
        showAddOrEditAddress() {

            if(!this.selectedAddress) {
                this.showAddAddress();
            }else{
                this.showEditAddress(this.selectedAddress);
            }

        },
        showAddAddress() {

            this.editType = 'create';

            if (AddressFieldService.isAddressFieldEnabled(this.addressToEdit.countryId, this.addressType, 'salutation')) {
                this.addressToEdit = {
                    addressSalutation : 0,
                    gender            : 'male',
                    countryId         : this.shippingCountryId,
                    showPickupStation : false
                };
            } else {
                this.addressToEdit = {countryId: this.shippingCountryId};
            }

            this.$store.commit('setAddressToEdit', {
                addressType: this.addressType,
                address:     this.addressToEdit
            });

            this.showAddressEditor = true;
            this.showAddress       = false;
            this.showAddressBook   = false;

        },

        showDeliverySelection() {

            if(this.isLoggedIn) {
                //delivery same as billing and no other address in address book
                if(
                    this.addressType === '2' &&
                    this.addressList.length === 1 &&
                    this.addressList[0].id === -99
                ) {
                    this.showAddAddress();
                }else{
                    this.showAddressEditor = false;
                    this.showAddress       = false;
                    this.showAddressBook   = true;
                }

            }else{
                this.showAddAddress();
            }

        },
        showEditAddress(address) {

            this.editType      = 'update';
            // Creates a tmp address to prevent unwanted two-way binding (plenty)
            this.addressToEdit = this.getAddressToEdit(address);

            if (this.addressToEdit.gender === 'female') {
                this.addressToEdit.addressSalutation = 1;
            }
            else if (isNull(this.addressToEdit.gender) && this.addressToEdit.name1) {
                this.addressToEdit.addressSalutation = 2;
            } else {
                this.addressToEdit.addressSalutation = 0;
                this.addressToEdit.gender            = 'male';
            }

            // if (
            //     isDefined(this.addressToEdit.address1) &&
            //     (this.addressToEdit.address1 === 'PACKSTATION' || this.addressToEdit.address1 === 'POSTFILIALE') &&
            //     this.$store.getters.isParcelOrOfficeAvailable
            // ) {
            //     this.addressToEdit.showPickupStation = true;
            // }

            //ValidationService.unmarkAllFields($(''));

            this.$store.commit('setAddressToEdit', {
                addressType: this.addressType,
                address:     this.addressToEdit
            });

            this.showAddressEditor = true;
            this.showAddress       = false;
            this.showAddressBook   = false;
        },
        getAddressToEdit(address) {

            const addressToEdit = JSON.parse(JSON.stringify(address));

            if (addressToEdit.options) {
                for (const option of addressToEdit.options) {

                    const optionName = this.addressOptionTypeFieldMap[option.typeId];

                    addressToEdit[optionName] = option.value || null;
                }
            }

            return addressToEdit;
        },
        getCountryName(countryId) {

            if (countryId > 0) {

                const country = this.countryList.find(country => country.id === countryId);

                if (!isNullOrUndefined(country)) {
                    return country.currLangName;
                }
            }

            return '';
        },
        getSalutationName(gender) {

            if(gender === null) {
                gender = 'company';
            }
            return TranslationService.translate('ODFashioncode::Fashioncode.checkoutGender' + gender);
        },
        showRemainingCollapse() {
            $('#id--checkout__accordion-collapse-shipping').collapse('show');
            $('#id--checkout__accordion-collapse-payment').collapse('show');
            $('#id--checkout__accordion-collapse-order').collapse('show');
        },

        isPackingStation(street) {

            /**
             * @link https://parcelshopfinder.dhlparcel.com/html/note_direct_access_germany.html?setLng=de
             */
            return (
                street.toLowerCase().indexOf('packstation') > -1 ||
                street.toLowerCase().indexOf('postoffice') > -1 ||
                street.toLowerCase().indexOf('postfiliale') > -1 ||
                street.toLowerCase().indexOf('packstation') > -1
            );
        }
    },


    filters: {
        optionType(selectedAddress, typeId) {

            if (selectedAddress && selectedAddress.name2) {
                for (const optionType of selectedAddress.options) {
                    if (optionType.typeId === typeId) {
                        return optionType.value;
                    }
                }
            }

            return '';
        }
    }
});
